var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vtextarea",class:{ error: !!_vm.error, border: !_vm.border, loading: _vm.loading }},[_c('textarea',{ref:"textarea",class:[
      'textarea',
      {
        resizable: _vm.resizable,
        'resizable-y': _vm.resizableY,
        'resizable-x': _vm.resizableX,
        auto_height: _vm.auto_height,
        'no-overflow': _vm.withoutOverflow
      }
    ],style:({ height: _vm.height ? _vm.height + 'px' : '' }),attrs:{"name":_vm.name,"placeholder":_vm.placeholder,"rows":_vm.rows ? _vm.rows : 2,"autofocus":_vm.autofocus,"disabled":_vm.disabled || _vm.loading,"maxlength":_vm.maxLength},domProps:{"value":_vm.value},on:{"input":_vm.handle_input,"blur":function($event){return _vm.$emit('blur')},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;if(!$event.altKey)return null;return _vm.$emit('keypress', $event.target.value)}}}),_vm._v(" "),(!!_vm.error)?_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }